import { CSSProperties } from 'react';
import { css } from 'styled-components';

import Theme from '../Theme/Theme';
import { TSpacing } from '../../components/Global/Atomics/types';

type MarginProps = {
    margin?: CSSProperties;
    theme: { spacing: typeof Theme.spacing };
};

type PaddingProps = {
    padding?: CSSProperties;
    theme: { spacing: typeof Theme.spacing };
};

export const customMarginStyles = css`
    margin: ${({ m, mt, mb, mr, ml, my, mx, margin, theme }: TSpacing & MarginProps): any => {
        // Note: Combination order is important in order to prioritize multiple combinations;

        // ------------------------- mt, mr, mb, ml ------------------------- //
        // Combination size 4
        if (mt && mr && mb && ml) return `${theme.spacing[mt]} ${theme.spacing[mr]} ${theme.spacing[mb]} ${theme.spacing[ml]}`;

        // Combination size 3
        if (mt && mr && mb) return `${theme.spacing[mt]} ${theme.spacing[mr]} ${theme.spacing[mb]} auto`;
        if (mt && mr && ml) return `${theme.spacing[mt]} ${theme.spacing[mr]} auto ${theme.spacing[ml]}`;
        if (mt && ml && mb) return `${theme.spacing[mt]} auto ${theme.spacing[mb]} ${theme.spacing[ml]}`;
        if (mr && ml && mb) return `auto ${theme.spacing[mr]} ${theme.spacing[mb]} ${theme.spacing[ml]}`;

        // Combination size 2
        if (mt && mr) return `${theme.spacing[mt]} ${theme.spacing[mr]} auto auto`;
        if (mt && ml) return `${theme.spacing[mt]} auto auto ${theme.spacing[ml]}`;
        if (mt && mb) return `${theme.spacing[mt]} auto ${theme.spacing[mb]} auto`;
        if (mr && ml) return `auto ${theme.spacing[mr]} auto ${theme.spacing[ml]}`;
        if (mr && mb) return `auto ${theme.spacing[mr]} ${theme.spacing[mb]} auto`;
        if (ml && mb) return `auto auto ${theme.spacing[mb]} ${theme.spacing[ml]}`;

        // Combination size 1 
        if (mt) return `${theme.spacing[mt]} 0 0 0`;
        if (mr) return `0 ${theme.spacing[mr]} 0 0`;
        if (mb) return `0 0 ${theme.spacing[mb]} 0`;
        if (ml) return `0 0 0 ${theme.spacing[ml]}`;

        // ------------------------------- my, mx ------------------------------- //
        // Combination size 2
        if (my && mx) return `${theme.spacing[my]} ${theme.spacing[mx]}`;

        // Combination size 1
        if (my) return `${theme.spacing[my]} auto`;
        if (mx) return `auto ${theme.spacing[mx]}`;

        // ---------------------------------- m ---------------------------------- //
        if (m) return `${theme.spacing[m]}`;

        return margin ? margin : null;
    }};
`;

export const customPaddingStyles = css`
    padding: ${({ p, pt, pb, pr, pl, py, px, padding, theme }: TSpacing & PaddingProps): any => {
        // Note: Combination order is important in order to prioritize multiple combinations;

        // ------------------------- pt, pr, pb, pl ------------------------- //
        // Combination size 4
        if (pt && pr && pb && pl) return `${theme.spacing[pt]} ${theme.spacing[pr]} ${theme.spacing[pb]} ${theme.spacing[pl]}`;

        // Combination size 3
        if (pt && pr && pb) return `${theme.spacing[pt]} ${theme.spacing[pr]} ${theme.spacing[pb]} 0`;
        if (pt && pr && pl) return `${theme.spacing[pt]} ${theme.spacing[pr]} 0 ${theme.spacing[pl]}`;
        if (pt && pl && pb) return `${theme.spacing[pt]} 0 ${theme.spacing[pb]} ${theme.spacing[pl]}`;
        if (pr && pl && pb) return `0 ${theme.spacing[pr]} ${theme.spacing[pb]} ${theme.spacing[pl]}`;

        // Combination size 2
        if (pt && pr) return `${theme.spacing[pt]} ${theme.spacing[pr]} 0 0`;
        if (pt && pl) return `${theme.spacing[pt]} 0 0 ${theme.spacing[pl]}`;
        if (pt && pb) return `${theme.spacing[pt]} 0 ${theme.spacing[pb]} 0`;
        if (pr && pl) return `0 ${theme.spacing[pr]} 0 ${theme.spacing[pl]}`;
        if (pr && pb) return `0 ${theme.spacing[pr]} ${theme.spacing[pb]} 0`;
        if (pl && pb) return `0 0 ${theme.spacing[pb]} ${theme.spacing[pl]}`;

        // Combination size 1 
        if (pt) return `${theme.spacing[pt]} 0 0 0`;
        if (pr) return `0 ${theme.spacing[pr]} 0 0`;
        if (pb) return `0 0 ${theme.spacing[pb]} 0`;
        if (pl) return `0 0 0 ${theme.spacing[pl]}`;

        // ------------------------------- py, px ------------------------------- //
        // Combination size 2
        if (py && px) return `${theme.spacing[py]} ${theme.spacing[px]}`;

        // Combination size 1
        if (py) return `${theme.spacing[py]} 0`;
        if (px) return `0 ${theme.spacing[px]}`;

        // ---------------------------------- m ---------------------------------- //
        if (p) return `${theme.spacing[p]}`;

        return padding ? padding : null;
    }};
`;
